import React from 'react';
import ReactDOMClient from 'react-dom/client';
import App from './App';
import './index.css';

import Modal from 'react-modal';

Modal.setAppElement('#root')
const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);  